"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PostMessageEventName;
(function (PostMessageEventName) {
    PostMessageEventName["IframeLoaded"] = "AMSIframeLoaded";
    PostMessageEventName["SkypeTokenAuth"] = "AMSSkypeTokenAuth";
    PostMessageEventName["CreateObject"] = "AMSCreateObject";
    PostMessageEventName["UploadDocument"] = "AMSUploadDocument";
    PostMessageEventName["GetViewStatus"] = "AMSGetViewStatus";
    PostMessageEventName["GetView"] = "AMSGetView";
    PostMessageEventName["SendTelemetry"] = "AMSSendTelemetry";
})(PostMessageEventName || (PostMessageEventName = {}));
exports.default = PostMessageEventName;
//# sourceMappingURL=PostMessageEventName.js.map